import { CalendarDays } from "lucide-react";

const WINDOWS = [
  { id: "d30", label: "Days 0 – 30", caption: "Stabilise & secure" },
  { id: "d60", label: "Days 31 – 60", caption: "Consolidate & close" },
  { id: "d90", label: "Days 61 – 90", caption: "Verify & sign off" }
];

export function ActionPlanTimeline({ plan }) {
  return (
    <section className="paper-card overflow-hidden">
      <div className="flex items-center justify-between border-b border-border bg-card/80 px-6 py-4">
        <div>
          <p className="eyebrow">§ 09 · Y — Your plan</p>
          <h3 className="font-display text-lg font-medium text-foreground">
            30 / 60 / 90 day readiness plan
          </h3>
        </div>
        <span className="hidden items-center gap-2 font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground sm:inline-flex">
          <CalendarDays className="h-3.5 w-3.5" />
          Sequenced windows
        </span>
      </div>
      <div className="grid grid-cols-1 gap-px bg-border md:grid-cols-3">
        {WINDOWS.map((window, idx) => (
          <div key={window.id} className="flex flex-col gap-4 bg-card p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                  {window.label}
                </p>
                <p className="mt-1 font-display text-base font-medium text-foreground">
                  {window.caption}
                </p>
              </div>
              <span className="letter-mark h-9 w-9 text-sm shadow-paper">
                {String(idx + 1).padStart(2, "0")}
              </span>
            </div>
            <div className="rule-tick" />
            <ol className="space-y-3">
              {plan[window.id].map((item, i) => (
                <li
                  key={`${window.id}-${i}-${item.slice(0, 24)}`}
                  className="flex items-start gap-3 text-sm leading-relaxed text-foreground"
                >
                  <span className="font-mono-label mt-0.5 text-[10px] uppercase tracking-[0.18em] text-muted-foreground">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ol>
          </div>
        ))}
      </div>
    </section>
  );
}
